import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button } from '@nextiva/next-ui-components';

import { NextivaAppBlock } from 'components';

import styles from './RoleProducts.scss';

class RoleProducts extends Component {
  onPermissionsClick = (slug) => () => {
    const { hash } = window.location;

    window.location.hash = `${hash}/permissions/${slug}`;
  };

  render() {
    const { products } = this.props;

    return (
      <div className={styles.appsContainer}>
        {products.list.map((app, index) => {
          return (
            <NextivaAppBlock key={index} {...app}>
              <Button
                disabled={!app.accessible}
                color="success"
                className={styles.permissionButton}
                onClick={this.onPermissionsClick(app.slug)}
                data-testid="PlatformAdminUI-RoleProducts-Button"
              >
                Permissions
              </Button>
            </NextivaAppBlock>
          );
        })}
      </div>
    );
  }
}

const mapStateToProps = ({ products }) => ({ products });

export default connect(mapStateToProps)(RoleProducts);
